import React, { useState, useEffect } from 'react';
import { useFlags } from 'wsm-common-data';
import PropTypes from 'prop-types';
import vehicleDataUpdated from '../utils/vehicleDataUpdated';

export default function LegacyTracking({ legacyConfigurations }) {
	const [isMounted, setIsMounted] = useState(null);
	const flags = useFlags();

	useEffect(() => {
		async function loadFiles() {
			const { default: runTrackingFramework } = await import(
				'../utils/legacy/framework/trackingFramework'
			);
			runTrackingFramework(window, flags);

			// TODO: Remove if we do not need this
			// document.dispatchEvent(
			// 	new Event('wsTaggingLegacyTrackingFrameworkReady')
			// );

			const { default: initProject } = await import(
				'../utils/legacy/projects/projects'
			);


			if (
				window.DDC?.dataLayer?.page?.pageInfo?.isVlp &&
				!window.DDC?.dataLayer?.vehicles?.length
			) {
				await vehicleDataUpdated(window);
			}
			const initiatingProjects = legacyConfigurations.map(
				(configuration) => initProject(window, flags, configuration)
			);

			const projects = await Promise.all(initiatingProjects);

			// All projects have the same listener
			// RuntimeBuilder.js is designed to share the listener between all instances of itself
			// So we only need to manually initialize using the listener from one project
			projects?.[0]?.listener?.manuallyInitialize?.(); // not expecting this to fail but just in case

			setIsMounted(true);
		}
		loadFiles();
	}, [legacyConfigurations, flags]);

	return isMounted ? <span placeholder="LegacyTracking" /> : null; // placholder is so we can grab this during unit testing
}

LegacyTracking.propTypes = {
	legacyConfigurations: PropTypes.objectOf(PropTypes.object)
};
